import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
import { gsap } from 'gsap'

if (document.getElementById('top')) {
  // #topがあるページだけで実行
  page()
}

function page() {
  // TOPページの処理
  document.addEventListener('DOMContentLoaded', () => {
    const mvSwiper = new Swiper('.js_mvSlider', {
      loop: true,
      effect: 'fade',
      speed: 900,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    })
  })
}

// Scroll HEADER Start===============================================
const header = document.getElementById('header')
if (header) {
  const hideThreshold = header.offsetHeight > 0 ? header.offsetHeight : 80
  let lastScrollY = window.scrollY
  let ticking = false

  const applyHeaderState = () => {
    const currentScrollY = window.scrollY

    if (currentScrollY > 10) {
      header.classList.add('is-scrolled')
    } else {
      header.classList.remove('is-scrolled')
    }

    if (currentScrollY > lastScrollY && currentScrollY > hideThreshold) {
      header.classList.add('is-hidden')
    } else {
      header.classList.remove('is-hidden')
    }

    lastScrollY = currentScrollY
    ticking = false
  }

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(applyHeaderState)
      ticking = true
    }
  }

  applyHeaderState()
  window.addEventListener('scroll', onScroll, { passive: true })
}
// Scroll HEADER End===============================================

// CF7のsubmitボタンをクリックしたら、指定のフォームにあるsubmitボタンをクリックする
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-cf7-submit').forEach((btn) => {
    btn.addEventListener('click', function () {
      // 指定のフォームを取得
      const form = btn.closest('form')
      if (form) {
        // 指定のフォームにあるsubmitボタンをクリック
        form.querySelector('[type="submit"]').click()
      }
    })
  })
})

//画像に適用されたblur-animeクラスをアニメーションさせる
const blurAnimeItems = document.querySelectorAll('.blur-anime')

if (blurAnimeItems.length > 0) {
  blurAnimeItems.forEach((item) => {
    gsap.set(item, { autoAlpha: 0, filter: 'blur(20px)' })
  })

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          gsap.to(entry.target, {
            autoAlpha: 1,
            filter: 'blur(0px)',
            duration: 1.2,
            ease: 'power2.out',
          })
          obs.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.2 }
  )

  blurAnimeItems.forEach((item) => observer.observe(item))
}
